import { render, staticRenderFns } from "./GoldTierModal.vue?vue&type=template&id=6c78b4af&scoped=true"
import script from "./GoldTierModal.vue?vue&type=script&lang=js"
export * from "./GoldTierModal.vue?vue&type=script&lang=js"
import style0 from "./GoldTierModal.vue?vue&type=style&index=0&id=6c78b4af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c78b4af",
  null
  
)

export default component.exports